import { 
    AP_RADIO_5GH_API_REQUEST,
    AP_RADIO_5GH_API_SUCCESS,
    AP_RADIO_5GH_API_FAIL,
    AP_RADIO_2GH_API_REQUEST,
    AP_RADIO_2GH_API_SUCCESS,
    AP_RADIO_2GH_API_FAIL,
    SITE_AP_RADIO_2GH_API_REQUEST,
    SITE_AP_RADIO_2GH_API_SUCCESS,
    SITE_AP_RADIO_2GH_API_FAIL,
    SITE_AP_RADIO_5GH_API_REQUEST,
    SITE_AP_RADIO_5GH_API_SUCCESS,
    SITE_AP_RADIO_5GH_API_FAIL,
    AP_RADIO_MCS_PHY_5GH_API_REQUEST,
    AP_RADIO_MCS_PHY_5GH_API_SUCCESS,
    AP_RADIO_MCS_PHY_5GH_API_FAIL,
    AP_RADIO_MCS_PHY_2GH_API_REQUEST,
    AP_RADIO_MCS_PHY_2GH_API_SUCCESS,
    AP_RADIO_MCS_PHY_2GH_API_FAIL
} from "../../constants/graphConstants/homeDashboardGraphConstant";

export const radioPerformanceGraphReducer = (state = { 
        siteDashboard: {
            rssi2 : [],
            rssi5 : [],
            loading2: false,
            loading5: false,
            error2: null,
            error5: null
        }, 
        apDashboard: {
            rssi2 : [],
            rssi5 : [],
            loading: false,
            error: null
        },
        apDashboardMcsPhy : {
          mcsPhy2: [],
          mcsPhy5: [],
          apiLoading2: false,
          apiLoading5: false,
          error2: null,
          error5: null
        } 
    },action
) => {
    switch (action.type) {
        case SITE_AP_RADIO_2GH_API_REQUEST:
          return {
            ...state,
            siteDashboard: {
                ...state.siteDashboard,
                rssi2 : [],
                loading2: true,
                error2: null
            }
          };
        case SITE_AP_RADIO_2GH_API_SUCCESS:
          return {
            ...state,
            siteDashboard: {
                ...state.siteDashboard,
                rssi2 : action.payload,
                loading2: false
            },
          };
        case SITE_AP_RADIO_2GH_API_FAIL:
          return {
            ...state,
            siteDashboard: {
                ...state.siteDashboard,
                rssi2 : [],
                loading2: false,
                error2: action.payload
            }
          };
        case SITE_AP_RADIO_5GH_API_REQUEST:
          return {
            ...state,
            siteDashboard: {
                ...state.siteDashboard,
                rssi5 : [],
                loading5: true,
                error5: null
            }
          };
        case SITE_AP_RADIO_5GH_API_SUCCESS:
          return {
            ...state,
            siteDashboard: {
                ...state.siteDashboard,
                rssi5 : action.payload,
                loading5: false
            },
          };
        case SITE_AP_RADIO_5GH_API_FAIL:
          return {
            ...state,
            siteDashboard: {
                ...state.siteDashboard,
                rssi5 : [],
                loading5: false,
                error5: action.payload
            }
          };
        case AP_RADIO_2GH_API_REQUEST:
            return {
              ...state,
              apDashboard: {
                  ...state.apDashboard,
                  rssi2 : [],
                  loading: true
              }
            };
        case AP_RADIO_2GH_API_SUCCESS:
            return {
              ...state,
              apDashboard: {
                  ...state.apDashboard,
                  rssi2 : action.payload,
                  loading: false
              },
            };
        case AP_RADIO_2GH_API_FAIL:
            return {
              ...state,
                apDashboard: {
                  ...state.apDashboard,
                  rssi2 : [],
                  loading: false,
                  error: action.payload
              }
            };
        case AP_RADIO_5GH_API_REQUEST:
            return {
              ...state,
                apDashboard: {
                  ...state.apDashboard,
                  rssi5 : [],
                  loading: true
              }
            };
        case AP_RADIO_5GH_API_SUCCESS:
            return {
              ...state,
                apDashboard: {
                  ...state.apDashboard,
                  rssi5 : action.payload,
                  loading: false
              },
            };
        case AP_RADIO_5GH_API_FAIL:
            return {
              ...state,
                apDashboard: {
                  ...state.apDashboard,
                  rssi5 : [],
                  loading: false,
                  error: action.payload
              }
            };
        case AP_RADIO_MCS_PHY_5GH_API_REQUEST:
          return {
            ...state,
              apDashboardMcsPhy: {
                ...state.apDashboardMcsPhy,
                mcsPhy5 : [],
                apiLoading5: true,
                error5: null
            }
          };
        case AP_RADIO_MCS_PHY_5GH_API_SUCCESS:
          return {
            ...state,
              apDashboardMcsPhy: {
                ...state.apDashboardMcsPhy,
                mcsPhy5 : action.payload,
                apiLoading5: false,
                error5: null
            }
          };
        case AP_RADIO_MCS_PHY_5GH_API_FAIL:
          return {
            ...state,
              apDashboardMcsPhy: {
                ...state.apDashboardMcsPhy,
                mcsPhy5 : [],
                apiLoading5: false,
                error5: action.payload
            }
          };
        case AP_RADIO_MCS_PHY_2GH_API_REQUEST:
          return {
            ...state,
              apDashboardMcsPhy: {
                ...state.apDashboardMcsPhy,
                mcsPhy2 : [],
                apiLoading2: true,
                error2: null
            }
          };
        case AP_RADIO_MCS_PHY_2GH_API_SUCCESS:
          return {
            ...state,
              apDashboardMcsPhy: {
                ...state.apDashboardMcsPhy,
                mcsPhy2 : action.payload,
                apiLoading2: false,
                error2: null
            }
          };
        case AP_RADIO_MCS_PHY_2GH_API_FAIL:
          return {
            ...state,
              apDashboardMcsPhy: {
                ...state.apDashboardMcsPhy,
                mcsPhy2 : [],
                apiLoading2: false,
                error2: action.payload
            }
          };
        default:
          return state;
      }
 }